import { createSelector } from 'reselect'

export const getCurrentUsertype = createSelector(
  state => state && state.user && state.user.registration && state.user.registration.currentUserType
    ? state.user.registration.currentUserType : null,
  usertype => usertype
)
